"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YachtingQualificationCatalogItemSchema = exports.YachtingQualificationSchema = exports.YachtingQualificationBaseSchema = exports.YACHTING_QUALIFICATION_SEED_ENTRIES = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
/** Legacy profile checkbox ids — seed inserts these exact _id values only when missing. */
exports.YACHTING_QUALIFICATION_SEED_ENTRIES = [
    { title: 'Officer of the Watch', id: '6245b42bc50e205768366af5' },
    { title: 'Y/M Offshore', id: '6245b42bc50e205768366af6' },
    { title: 'Y/M Ocean', id: '6245b42bc50e205768366af7' },
    { title: 'Master (Yachts) 500GT', id: '6245b42bc50e205768366af8' },
    { title: 'Chief Mate (Yachts)', id: '6245b42bc50e205768366af9' },
    { title: 'Chief Mate (Unlimited)', id: '6245b42bc50e205768366afa' },
    { title: 'Master (Yachts) 3000 GT', id: '6245b42bc50e205768366afb' },
    { title: 'Master (Unlimited)', id: '6245b42bc50e205768366afc' },
    { title: 'AEC', id: '6245b42bc50e205768366afd' },
    { title: 'MEOL', id: '6245b42bc50e205768366afe' },
    { title: 'Y4 Chief Engineer', id: '6245b42bc50e205768366aff' },
    { title: 'Y3 Chief Engineer', id: '6245b42bc50e205768366b00' },
    { title: 'Y2 Chief Engineer', id: '6245b42bc50e205768366b01' },
    { title: 'Y1 Chief Engineer', id: '6245b42bc50e205768366b02' },
    { title: 'SV EOOW Yacht (Restricted)', id: '6245b42bc50e205768366b03' },
    { title: 'SV Ch.Eng. Yacht (Restricted) < 3000 kW, <500 GT', id: '6245b42bc50e205768366b04' },
    { title: 'SV Ch.Eng. Yacht (Restricted) < 9000 kW, 3000 GT', id: '6245b42bc50e205768366b05' },
    { title: 'SV EOOW Yacht (Unlimited)', id: '6245b42bc50e205768366b06' },
    { title: 'SV Ch.Eng. (Unlimited) < 3000 kW, < 500 GT', id: '6245b42bc50e205768366b07' },
    { title: 'SV Ch.Eng. (Unlimited) < 9000 kW, < 3000 GT', id: '6245b42bc50e205768366b08' },
    { title: 'Guest Yacht Junior Steward / Stewardess', id: '6245b42bc50e205768366b09' },
    { title: 'Guest Yacht Senior Steward / Stewardess', id: '6245b42bc50e205768366b0a' },
    { title: 'Guest Yacht Chief Steward / Stewardess', id: '6245b42bc50e205768366b0b' },
    { title: 'Guest Yacht Purser', id: '6245b42bc50e205768366b0c' },
    { title: 'MCA Master 200', id: '6245b42bc50e205768366b0d' },
];
exports.YachtingQualificationBaseSchema = zod_1.z.object({
    Name: zod_1.z.string().trim().min(1, 'The name is required').max(200, 'The name is too long'),
    Order: zod_1.z.number().int().min(0).default(0),
    isHidden: zod_1.z.boolean().default(false).optional(),
    hiddenAt: zod_1.z.coerce.date().nullable().optional(),
    hiddenBy: zod_1.z.instanceof(ObjectId_1.ObjectId).nullable().optional(),
});
exports.YachtingQualificationSchema = exports.YachtingQualificationBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.YachtingQualificationCatalogItemSchema = zod_1.z.object({
    _id: zod_1.z.string(),
    Name: zod_1.z.string(),
    Order: zod_1.z.number(),
    isHidden: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=YachtingQualification.js.map